module.exports = __webpack_public_path__ + "2acb60f2/img/product-icon-grey.b248963c.svg";